<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap>
      <v-flex md4>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.operativos.rep.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <!-- Clave -->
                  <v-text-field v-if="rep.clave" v-model="rep.clave" :label="$t('view.commons.clave')" disabled />

                  <!-- Clave REP -->
                  <v-text-field
                    v-model.trim="$v.rep.code.$model"
                    :error-messages="getFirstErrorDescription($v.rep.code)"
                    :label="$t('view.operativos.rep.form.code.label')"
                    maxlength="5"
                    :disabled="view.action.submit.busy"
                    onkeypress="return /^[0-9]*$/.test(event.key);" />

                  <!-- Nombre -->
                  <v-text-field
                    v-model.trim="$v.rep.nombre.$model"
                    :label="$t('view.operativos.rep.form.nombre.label')"
                    :error-messages="getFirstErrorDescription($v.rep.nombre)"
                    maxlength="50"
                    :disabled="view.action.submit.busy"
                    onkeypress="return /^[a-zA-Z0-9\r\.\+\-\_\ ]+$/.test(event.key);" />

                  <!-- Apellido -->
                  <v-text-field
                    v-model.trim="$v.rep.apellido.$model"
                    :label="$t('view.operativos.rep.form.apellido.label')"
                    :error-messages="getFirstErrorDescription($v.rep.apellido)"
                    maxlength="50"
                    :disabled="view.action.submit.busy"
                    onkeypress="return /^[a-zA-Z0-9\r\.\+\-\_\ ]+$/.test(event.key);" />

                  <!-- Tipo -->
                  <v-flex md12>
                    <v-autocomplete
                      v-model.trim="$v.rep.tipo.$model"
                      :label="$t('view.operativos.rep.form.tipo.label')"
                      :error-messages="getFirstErrorDescription($v.rep.tipo)"
                      :items="view.elem.select.tipo.filteredList"
                      :disabled="view.action.submit.busy || view.elem.select.tipo.disabled"
                      item-value="code"
                      item-text="name"
                      hide-selected
                      deletable-chips
                      clearable
                      multiple
                      small-chips
                      :no-data-text="$t('view.commons.nodata')"
                      @input="search = ''" />
                  </v-flex>

                  <!-- Vendor readonly -->
                  <v-flex md12>
                    <v-autocomplete
                      v-model="vendorsRep"
                      :label="$t('view.operativos.rep.form.vendor.label')"
                      :items="view.elem.select.vendor.filteredList"
                      disabled
                      item-value="code"
                      item-text="name"
                      hide-selected
                      multiple
                      small-chips
                      :no-data-text="$t('view.commons.nodata')" />
                  </v-flex>

                  <!-- Estatus -->
                  <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                  <v-switch v-model="rep.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="rep.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>

      <v-flex md8>
        <data-table ref="repTable" @editRow="load" @auditRow="audit" />
      </v-flex>
    </v-layout>
    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import repStates from "@/views/operativos/rep/rep-state"; /** *******************************/
import repAPI from "@/services/operativos/rep"; /** *******************************/
import DataTable from "@/views/operativos/rep/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required } from "vuelidate/lib/validators";
import { fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { TIPO_SELECT } from "@/constants/operativos";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";

const select = {
  tipo: {
    filteredList: TIPO_SELECT
    , disabled: false
  }
  , vendor: { filteredList: [] }
};

const action = { submit: { busy: false } };

export default {
  name: "RepModule"
  , components: {
    DataTable
    , Auditoria
  }
  , data() {
    return {
      rep: undefined
      , form: new Object()
      , vendorsRep: []
      , view: {
        title: this.$t("view.operativos.rep.title")
        , action
        , elem: {
          button: { submit }
          , select
          , showForm: true
        }
      }
      , check: true
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.loadSelectData();
    this.form = new repStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async loadSelectData() {
      const { data: { results: { combo: vendorList } } } = await CombosAPI.get({ option: "vendor" });
      this.view.elem.select.vendor.filteredList = vendorList || [];
    }
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.rep);
        handleResponse(respuesta, this.$t("view.operativos.rep.errors"));
      } catch (error) {
        handleResponse(error, this.$t("view.operativos.rep.errors"));
      }
    }
    , async load(clave) {
      try {
        const response = await repAPI.get(clave);
        const { data: { results: { rep } } } = response;
        this.form.$setState("editing", rep);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.rep.clave, dataDescripcion = this.rep.nombre + " " + this.rep.apellido) {
      this.$refs.auditModal.loadAudit(clave, "TRep", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
  }
  , validations: {
    rep: {
      code: { required }
      , nombre: { required, fixMigImp: fixMigImp() }
      , apellido: { required, fixMigImp: fixMigImp() }
      , tipo: { required }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/operativos/rep/Rep.vue